// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import injectTapEventPlugin from 'react-tap-event-plugin'

import { Header } from '../components/header'
import { Footer } from '../components/footer'

import workerData from '../data/workforce.json'

injectTapEventPlugin()

export class Template extends Component {

    constructor(props) {
        super(props)

        //this.env = "localhost"
        this.env = "staging"
        //this.env = "production"
        console.log("Running " + this.env)

        this.state = {
            loginStatus: false,
            profileType: 'provider',
            authToken: '',
            uid: '',
            fname: '',
            lname: '',
            email: '',
            company: '',
            address: '',
            licenseCount: '',
            average_strikes: 0,
            confirmed: false,
            gender: '',
            purpose: '',
            last_active_at: '',
            workers: workerData,
            selectedWorkers: [],
            globalModules: []
        }

        this.handleLoginStateChange = this.handleLoginStateChange.bind(this)
        this.handleAuthToken = this.handleAuthToken.bind(this)
        this.handleSetProfileType = this.handleSetProfileType.bind(this)
        this.handleProviderDataUpdate = this.handleProviderDataUpdate.bind(this)
        this.handleWorkerDataUpdate = this.handleWorkerDataUpdate.bind(this)
        this.handleProviderWorkerDataUpdate = this.handleProviderWorkerDataUpdate.bind(this)
        this.getWorkerDetails = this.getWorkerDetails.bind(this)
        this.getWorkerScenarios = this.getWorkerScenarios.bind(this)
        this.handleWorkerModules = this.handleWorkerModules.bind(this)
        this.handleUpdateProviderSettings = this.handleUpdateProviderSettings.bind(this)
        this.handleUpdateWorkerSettings = this.handleUpdateWorkerSettings.bind(this)
        this.handleGlobalModuleData = this.handleGlobalModuleData.bind(this)
        this.getWorkersByProvider = this.getWorkersByProvider.bind(this)
        this.getWorkerModulesFromApi = this.getWorkerModulesFromApi.bind(this)
        this.getWorkerModuleActivity = this.getWorkerModuleActivity.bind(this)
        this.handleProviderDataUpdateFromSessionStorage = this.handleProviderDataUpdateFromSessionStorage.bind(this)
        this.handleWorkerDataUpdateFromSessionStorage = this.handleWorkerDataUpdateFromSessionStorage.bind(this)
        this.handleRemoveWorker = this.handleRemoveWorker.bind(this)
        this.handleSelectedWorkers = this.handleSelectedWorkers.bind(this)
        this.handleEmail = this.handleEmail.bind(this)
    }

    handleLoginStateChange(status, location) {
        this.setState({
            loginStatus: status
        })

        window.sessionStorage.setItem('loginStatus', status)

        if (location) {
            this.props.router.push('/' + location)
        }
    }

    handleAuthToken(auth) {
        this.setState({
            authToken: auth
        })

        window.sessionStorage.setItem('authToken', auth)
    }

    handleEmail(email) {
        this.setState({
            email: email
        })

        window.sessionStorage.setItem('email', email)
    }

    handleUpdateProviderSettings(formData) {

        this.setState({
            fname: formData.admin_first_name,
            lname: formData.admin_last_name,
            company: formData.name,
            address: formData.address
        })

        if (window.sessionStorage.getItem('fname') !== formData.admin_first_name) {
            window.sessionStorage.setItem('fname', formData.admin_first_name)
        }
        if (window.sessionStorage.getItem('lname') !== formData.admin_last_name) {
            window.sessionStorage.setItem('lname', formData.admin_last_name)
        }
        if (window.sessionStorage.getItem('company') !== formData.name) {
            window.sessionStorage.setItem('company', formData.name)
        }
        if (window.sessionStorage.getItem('address') !== formData.address) {
            window.sessionStorage.setItem('address', formData.address)
        }
    }

    handleUpdateWorkerSettings(formData) {
        let newWorker = this.state.workers

        newWorker[0].first_name = formData.first_name
        newWorker[0].last_name = formData.last_name
        newWorker[0].gender = formData.gender
        newWorker[0].purpose = formData.purpose

        this.setState({
            workers: newWorker
        })

        window.sessionStorage.setItem('workers', JSON.stringify(newWorker))

        if (window.sessionStorage.getItem('first_name') !== formData.first_name) {
            window.sessionStorage.setItem('first_name', formData.first_name)
        }
        if (window.sessionStorage.getItem('last_name') !== formData.last_name) {
            window.sessionStorage.setItem('last_name', formData.last_name)
        }
        if (window.sessionStorage.getItem('gender') !== formData.gender) {
            window.sessionStorage.setItem('gender', formData.gender)
        }
        if (window.sessionStorage.getItem('purpose') !== formData.purpose) {
            window.sessionStorage.setItem('purpose', formData.purpose)
        }
    }

    handleGlobalModuleData(data) {
        this.setState({
            globalModules: data
        })

        window.sessionStorage.setItem('globalModules', JSON.stringify(data))
    }

    handleSetProfileType(type) {
        this.setState({
            profileType: type
        })

        window.sessionStorage.setItem('profileType', type)
    }

    handleProviderDataUpdate(data) {
        this.setState({
            uid: data.id,
            fname: data.admin_first_name,
            lname: data.admin_last_name,
            company: data.name,
            address: data.address,
            licenseCount: data.license_count
        })

        window.sessionStorage.setItem('uid', data.id)
        window.sessionStorage.setItem('fname', data.admin_first_name)
        window.sessionStorage.setItem('lname', data.admin_last_name)
        window.sessionStorage.setItem('company', data.name)
        window.sessionStorage.setItem('address', data.address)
        window.sessionStorage.setItem('licenseCount', data.license_count)
    }


    handleRemoveWorker(workerId) {
        let newWorkers = this.state.workers.filter(worker => {
            return worker.id !== parseInt(workerId)
        })

        this.setState({
            workers: newWorkers
        })
    }

    handleProviderDataUpdateFromSessionStorage(data) {
        this.setState({
            loginStatus: data.loginStatus,
            profileType: data.profileType,
            authToken: data.authToken,
            uid: data.id,
            fname: data.admin_first_name,
            lname: data.admin_last_name,
            company: data.name,
            address: data.address,
            licenseCount: data.license_count,
            email: data.email,
            globalModules: data.globalModules
        })
    }

    handleWorkerDataUpdate(data) {
        data.modules = []
        let worker = new Array(data)

        this.setState({
            average_strikes: data.average_strikes,
            confirmed: data.confirmed,
            email: data.email,
            gender: data.gender,
            purpose: data.purpose,
            uid: data.id,
            first_name: data.first_name,
            last_name: data.last_name,
            last_active_at: data.last_active_at,
            workers: worker
        })

        window.sessionStorage.setItem('average_strikes', data.average_strikes)
        window.sessionStorage.setItem('confirmed', data.confirmed)
        window.sessionStorage.setItem('email', data.email)
        window.sessionStorage.setItem('gender', data.gender)
        window.sessionStorage.setItem('purpose', data.purpose)
        window.sessionStorage.setItem('uid', data.id)
        window.sessionStorage.setItem('first_name', data.first_name)
        window.sessionStorage.setItem('last_name', data.last_name)
        window.sessionStorage.setItem('last_active_at', data.last_active_at)
        window.sessionStorage.setItem('workers', JSON.stringify(worker))
    }

    handleWorkerDataUpdateFromSessionStorage(data) {
        this.setState({
            loginStatus: data.loginStatus,
            profileType: data.profileType,
            authToken: data.authToken,
            average_strikes: data.average_strikes,
            confirmed: data.confirmed,
            email: data.email,
            gender: data.gender,
            purpose: data.purpose,
            uid: data.id,
            first_name: data.first_name,
            last_name: data.last_name,
            last_active_at: data.last_active_at,
            workers: data.workers,
            globalModules: data.globalModules
        }, () => {
            this.getWorkerModulesFromApi()
        })
    }

    getWorkersByProvider() {

    }

    handleProviderWorkerDataUpdate(workers) {
        let workerPromises = workers.map((worker, index) => {
            return this.getWorkerDetails(worker, index)
        })

        Promise.all(workerPromises).then(workers => {
            this.setState({
                workers: workers
            })
        })
    }

    getWorkerModulesFromApi() {
    }

    getWorkerModuleActivity(emptyModules) {
    }

    getWorkerDetails(worker, index) {
    }

    handleWorkerModules(modulesFromApi, modulesWithActivities) {
    }

    mergeModules(emptyModules, modulesWithActivities) {
    }

    getEmptyModules(rawData = []) {
    }

    getEmptyScenarios(rawData, moduleName) {
    }

    getWorkerScenarios(workerGames) {
    }

    isScenarioComplete(scenarioData) {

        for (let i = 0; i < (scenarioData.length); i++) {
            if (scenarioData[i].tracking_data.completed) {
                return true
            }
        }

        return false
    }

    getScenarioScores(scenarioData) {
    }

    getWorkerModules(scenarios) {
    }

    getModuleName(scenario) {
        switch (scenario) {
            case "Manual Assistance": return "Physical Support"

            case "Recognising Abuse and Neglect": return "Disability Support"

            case "Intro to Disability": return "Disability Support"

            default: return ""
        }
    }

    isModuleComplete(moduleData) {

        for (let i = 0; i < (moduleData.length); i++) {
            if (moduleData[i].completed) {
                return true
            }
        }

        return false
    }

    getModuleStrikes(moduleData) {

        let totalStrikes = 0

        for (let i = 0; i < (moduleData.length); i++) {
            totalStrikes += moduleData[i].strikes

        }

        return Math.round(totalStrikes / moduleData.length, -2)
    }

    handleSelectedWorkers(selectedWorkers) {
        this.setState({
            selectedWorkers
        })
    }

    render() {
        let childWithProps = React.Children.map(this.props.children, child => {
            return (
                React.cloneElement(child, {
                    handleLoginStateChange: this.handleLoginStateChange,
                    handleAuthToken: this.handleAuthToken,
                    handleSetProfileType: this.handleSetProfileType,
                    handleProviderDataUpdate: this.handleProviderDataUpdate,
                    handleWorkerDataUpdate: this.handleWorkerDataUpdate,
                    handleProviderWorkerDataUpdate: this.handleProviderWorkerDataUpdate,
                    handleWorkerModules: this.handleWorkerModules,
                    handleUpdateWorkerSettings: this.handleUpdateWorkerSettings,
                    getWorkersByProvider: this.getWorkersByProvider,
                    handleUpdateProviderSettings: this.handleUpdateProviderSettings,
                    getWorkerModulesFromApi: this.getWorkerModulesFromApi,
                    getWorkerModuleActivity: this.getWorkerModuleActivity,
                    handleGlobalModuleData: this.handleGlobalModuleData,
                    handleProviderDataUpdateFromSessionStorage: this.handleProviderDataUpdateFromSessionStorage,
                    handleWorkerDataUpdateFromSessionStorage: this.handleWorkerDataUpdateFromSessionStorage,
                    handleRemoveWorker: this.handleRemoveWorker,
                    handleSelectedWorkers: this.handleSelectedWorkers,
                    handleEmail: this.handleEmail,
                    appData: this.state,
                    env: this.env
                })
            )
        })

        return (
            <MuiThemeProvider>
                <div>
                    <Header
                        handleLoginStateChange={this.handleLoginStateChange}
                        location={this.props.location}
                        loginStatus={this.state.loginStatus}
                        profileType={this.state.profileType}
                    />
                    <main>
                        {childWithProps}
                    </main>
                    <Footer />
                </div>
            </MuiThemeProvider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/template.js